(() => {
  const page = document.querySelector('.lr50');
  if (!page) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveals = [...page.querySelectorAll('[data-lr-reveal]')];
  const panels = [...page.querySelectorAll('[data-lr-parallax]')];

  if ('IntersectionObserver' in window && !reducedMotion.matches) {
    page.classList.add('lr50-enhanced');
    requestAnimationFrame(() => requestAnimationFrame(() => page.classList.add('lr50-ready')));
    const observer = new IntersectionObserver((entries, current) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lr50-visible');
        current.unobserve(entry.target);
      });
    }, { threshold: 0.13, rootMargin: '0px 0px -25px 0px' });
    reveals.forEach((element) => observer.observe(element));
  }

  let queued = false;
  const render = () => {
    queued = false;
    if (reducedMotion.matches) {
      panels.forEach((panel) => panel.style.removeProperty('--lr-shift'));
      return;
    }
    const viewport = window.innerHeight;
    panels.forEach((panel) => {
      const rect = panel.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewport) return;
      const progress = (viewport - rect.top) / (viewport + rect.height);
      const limit = panel.classList.contains('lr50-strength__photo') ? 22 : 35;
      const shift = Math.max(-limit, Math.min(limit, (progress - .5) * limit * 2));
      panel.style.setProperty('--lr-shift', `${shift.toFixed(1)}px`);
    });
  };
  const queueRender = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(render);
  };

  window.addEventListener('scroll', queueRender, { passive: true });
  window.addEventListener('resize', queueRender, { passive: true });
  reducedMotion.addEventListener?.('change', queueRender);
  page.querySelectorAll('a[href^="#lr50-"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target || !page.contains(target)) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.hash);
    });
  });
  queueRender();
})();
